import React, { PropsWithChildren, useMemo, useRef } from "react";

import {
  ProductTileClickImpressionContext,
  IProductTileClickImpressionContextValue,
} from "@faire/retailer/hooks/ProductTileImpression/__internal__/ProductTileClickImpressionContext";

type IProductTileClickImpressionProviderProps = Omit<
  IProductTileClickImpressionContextValue,
  "badgeEventTokens"
>;

export const ProductTileClickImpressionProvider: React.FC<
  PropsWithChildren<IProductTileClickImpressionProviderProps>
> = ({
  children,
  containerName,
  context,
  productTileContainer,
  requestId,
  isNewProductsCategory,
}) => {
  const badgeEventTokens = useRef<Set<string>>(new Set());

  const value = useMemo<IProductTileClickImpressionContextValue>(() => {
    return {
      requestId,
      containerName: containerName?.replace("_old", ""),
      context,
      productTileContainer,
      badgeEventTokens: badgeEventTokens.current,
      isNewProductsCategory,
    };
  }, [
    containerName,
    productTileContainer,
    context,
    requestId,
    isNewProductsCategory,
  ]);

  return (
    <ProductTileClickImpressionContext.Provider value={value}>
      {children}
    </ProductTileClickImpressionContext.Provider>
  );
};
